export const nonDismissibleAlertMessages = [
  'bounds-credit-report-expired',
  'bounds-hoi-expired',
  'bounds-appraisal-report-expired',
  'bounds-title-report-expired',
  'bounds-payoff-expired',
  'cost-benefit-ratio-below-5',
  'bounds-investment-amount-is-zero',
]

export const docExpiredAlertMessages = [
  'bounds-credit-report-expired',
  'bounds-hoi-expired',
  'bounds-appraisal-report-expired',
  'bounds-title-report-expired',
  'bounds-payoff-expired',
]
